import { Link } from 'react-router-dom';
import type { Film } from '@/types/film';
import { formatHeat, typeLabel } from '@/lib/film';

interface HotListProps {
  items: Film[];
}

export default function HotList({ items }: HotListProps) {
  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2 md:gap-4">
      {items.map((film, index) => (
        <Link
          key={film.id}
          to={`/detail/${film.id}`}
          className="group flex cursor-pointer items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors duration-300 hover:border-primary-300 hover:bg-primary-50/60"
        >
          <span
            className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
              index < 3 ? 'bg-accent-500 text-primary-950' : 'bg-background-200 text-foreground-600'
            }`}
          >
            {String(index + 1).padStart(2, '0')}
          </span>
          <div className="h-[92px] w-16 shrink-0 overflow-hidden rounded-md bg-primary-900">
            <img
              src={film.cover}
              alt={`${film.title} 封面`}
              title={`${film.title} - 青青草影视详情`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2">
              <h3 className="truncate font-heading text-[15px] font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                {film.title}
              </h3>
              <span className="shrink-0 rounded bg-background-100 px-1.5 py-0.5 text-[10px] text-foreground-500">
                {typeLabel(film.type)}
              </span>
            </div>
            <p className="mt-1 truncate text-xs text-foreground-500">
              {film.genres.join(' / ')} · {film.year} · {film.region}
            </p>
            <div className="mt-2 flex items-center gap-3 text-xs">
              <span className="flex items-center gap-1 font-semibold text-accent-600">
                <i className="ri-star-fill text-[10px]" />
                {film.rating.toFixed(1)}
              </span>
              <span className="flex items-center gap-1 text-foreground-400">
                <i className="ri-eye-line text-sm" />
                {formatHeat(film.heat)}
              </span>
            </div>
          </div>
          <i className="ri-arrow-right-line shrink-0 text-foreground-300 transition-colors group-hover:text-primary-600" />
        </Link>
      ))}
    </div>
  );
}